import React, { useEffect,useState} from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Bread from '../component/Breadcrumbs';
import Sidebar from '../component/Sidebar';
import Datatable from '../component/Datatable';
import {UserList} from '../Services/User';
import {AuthData} from '../Services/Authdata';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MaterialIcons from '../component/MaterialIcons';
import FlightDetail from '../Pages/FlightDetail';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


const FlightBooking = () =>  {
  const br = [{
    'title':'Flight',
    'icon':"",
    'url':'/flight'
  }];
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [srow, setSrow] = useState([]);
  const [open, setOpen] = React.useState(false);
  useEffect(() =>{
    UserList('admin/booking','GET',AuthData().token).then((result)=>{
      setData(result.data);
    })
  },[])

  const columns = [
    {
     name: "id",
     label: "User",
     options: {
      filter: true,
      sort: true,
      customBodyRenderLite:(value, dataIndex,updateValue) => { return data[dataIndex].user.name; }}
    },
    {
     name: "status",
     label: "Payment",
     options: {
      filter: true,
      sort: false,
      customBodyRenderLite:(value, dataIndex,updateValue) => {return "Success";}}
    },
    {
      name: "bookingStatus",
      label: "Booking Status",
      options: {
       filter: true,
       sort: false,
      }
     },
     {
      name: "booking_id",
      label: "Booking Id",
      options: {
       filter: true,
       sort: false,
      }
     },
     {
      name: "booking",
      label: "Fare",
      options: {
       filter: true,
       sort: false,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
         var bookingPrice = data[dataIndex].booking.TravelItinerary.ItineraryInfo.ItineraryPricing.EquiFare.Amount
         return bookingPrice;
        }

      }
     },
     {
      name: "booking",
      label: "Taxes",
      options: {
       filter: true,
       sort: false,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
        var bookingPrice = data[dataIndex].booking.TravelItinerary.ItineraryInfo.ItineraryPricing;
        var bookingPriceAmount = parseFloat(bookingPrice.ServiceTax.Amount) + parseFloat(bookingPrice.Tax.Amount);
        return bookingPriceAmount.toFixed(2);
      }

      }
     },
     {
      name: "booking",
      label: "Commission",
      options: {
       filter: true,
       sort: false,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
        var bookingPriceAmount = parseFloat(data[dataIndex].commission);
         return bookingPriceAmount.toFixed(2);;
      }

      }
     },
     {
      name: "booking",
      label: "Amount",
      options: {
       filter: true,
       sort: false,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
          var bookingPrice = data[dataIndex].booking.TravelItinerary.ItineraryInfo.ItineraryPricing.TotalFare
          var bookingPriceAmount = parseFloat(bookingPrice.Amount) + parseFloat(data[dataIndex].commission);
         return bookingPrice.CurrencyCode+" "+(Math.round(bookingPriceAmount * 100) / 100).toFixed(2);;
      }

      }
     },
     {
      name: "booking",
      label: "Destination",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
          var bookingDest = data[dataIndex].booking.TravelItinerary;
            return bookingDest.Origin+" - "+bookingDest.Destination;
          }
        }
     },
     {
      name: "booking_id",
      label: "Invoice",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
          var bookingId = data[dataIndex].booking.TravelItinerary.UniqueID;
            return (
            <div onClick={(e)=>{window.location.replace(process.env.REACT_APP_BASEAPI_URL+'booking/invoice/'+bookingId)}} style={{cursor:"pointer"}}>
                <MaterialIcons color="secondary" icon="download" size={20} />
            </div>);
          }
        }
     },
   ];
   const options = {
    filterType: 'dropdown',
    selectableRowsOnClick:false,
  //  selectableRows: "none",
    // draggableColumns: {
    //   enabled: true
    // },
    responsive: 'standard',
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    renderExpandableRow: (rowData, rowMeta) => {
      const bookingItienary = data[rowMeta['dataIndex']].booking.TravelItinerary;
      return (
        <FlightDetail data={bookingItienary} commission={data[rowMeta['dataIndex']].commission}/>
        
      );
    },
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => console.log(curExpanded, allExpanded, rowsExpanded),

   //  selectedRows: {
   //   text: "row(s) sdsdsdsdsselected",
   //   delete: "Delete",
   //   deleteAria: "Delete Selected Rows",
   // },
    onRowSelectionChange:(currentRowsSelected, allRowsSelected, rowsSelected) => {
       const abc = rowsSelected.map((r)=>{
         return data[r].id;
       })
        setSrow(abc);
    },
    //selectToolbarPlacement:"none",
    // customToolbarSelect:(selectedRows, displayData, setSelectedRows) =>{
    //  return (
    //    <div>
    //      <Button title="Block" onClick={()=>userBlock(0,srow)}>
    //        <MaterialIcons color="action" icon="verified_user" size={20}/>
    //    </Button>
    //    <Button title="Unblock" onClick={()=>userBlock(1,srow)}>
    //        <MaterialIcons color="secondary" icon="verified_user" size={20}/>
    //    </Button>
    //    </div>
    //  )
    // },
  };

  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br}/>
       <h1>Flight</h1>
       <Datatable title="Flight Booking" data={data} columns={columns} options={options}/>
      </main>
    </div>
    
   
  );
}

export default FlightBooking;


// WEBPACK FOOTER //
// ./src/Pages/FlightBooking.js